import {
  Button,
  Icons,
  HexIcon,
  ExternalLink,
  Placeholder as StatusMessage,
} from '@cast/design-system';

import { getDocsLink } from '@cast/utils';

type EdgeLocationsEmptyStateProps = {
  title: string;
  testId: string;
  actionLabel: string;
  hasPermission: boolean;
  onActionClick: () => void;
};

export const EdgeLocationsEmptyState = ({
  title,
  testId,
  actionLabel,
  hasPermission,
  onActionClick,
}: EdgeLocationsEmptyStateProps) => {
  return (
    <StatusMessage
      testId={testId}
      icon={
        <HexIcon
          size={64}
          icon={<Icons.Nut />}
          iconColor="blue.500"
          hexColor="blue.300"
          sx={{ mb: 4 }}
        />
      }
      title={title}
      titleProps={{ typography: 'h5' }}
      body={
        <>
          Extend your cluster beyond its primary region to access compute
          capacity in different regions and cloud providers. Once created, edge
          locations can be used by the Autoscaler to optimize node placement.{' '}
          <ExternalLink
            link={getDocsLink('docs_omni_overview')}
            iconProps={{ size: 16 }}
          >
            Documentation
          </ExternalLink>
        </>
      }
      bodyProps={{ typography: 'P14R', maxWidth: '684px' }}
      actions={
        <Button
          testId={`${testId}-button`}
          onClick={onActionClick}
          variant="primary"
          disabled={!hasPermission}
        >
          {actionLabel}
        </Button>
      }
    />
  );
};
